
import React from "react";
import { Routes, Route, } from "react-router-dom";  
import { RouteConstant } from "./RouteConstant";
import PageLayout from "../screens/Layout";
import UserList from "../screens/User/UserList";
import VesselScreen from "../screens/Vessel/VesselScreen";
import DashboardLayout from "../screens/Dashboard/DashboardLayout";
import SectionProgress from "../screens/Inspection/SectionProgress";
import QuestionProgress from "../screens/Inspection/QuestionProgress/QuestionProgress";
import RemarkScreen from "../screens/Inspection/QuestionProgress/RemarkScreen";

const CompanyAdminRoutes = () => {
  return (
    <Routes>
        <Route path={RouteConstant.ROOT} element={<PageLayout />}>
            <Route path={RouteConstant.ROOT} element={<DashboardLayout />} />
            <Route path={RouteConstant.USERS} element={<UserList />} />
            <Route path={RouteConstant.VESSEL} element={<VesselScreen />} />
            <Route path={RouteConstant.SECTIONPROGRESS} element={<SectionProgress />} />
            <Route path={RouteConstant.QUESTIONPROGRESS} element={<QuestionProgress />} />
            <Route path={RouteConstant.REMARKSCREEN} element={<RemarkScreen />} />
        </Route>
    </Routes>
  );
}

export default CompanyAdminRoutes;